(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styr-header"]) return;
  try {
    
  (() => {
    const initialize = (shell) => {
      if (!shell || shell.dataset.styrReady === 'true') return;
      shell.dataset.styrReady = 'true';
      const toggle = shell.querySelector('[data-styr-menu-toggle]');
      const nav = shell.querySelector('[data-styr-nav]');
      const progress = shell.querySelector('[data-styr-progress]');
      const closeMenu = () => {
        toggle?.classList.remove('is-open');
        nav?.classList.remove('is-open');
        toggle?.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      };
      toggle?.addEventListener('click', () => {
        const open = !toggle.classList.contains('is-open');
        toggle.classList.toggle('is-open', open);
        nav?.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });
      nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
      shell.querySelectorAll('[data-styr-language]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));
      const update = () => {
        shell.classList.toggle('is-scrolled', window.scrollY > 24);
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        progress?.style.setProperty('--styr-progress', String(scrollable > 0 ? Math.min(1, window.scrollY / scrollable) : 0));
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    };
    document.querySelectorAll('[data-styr-header]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-styr-header]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styr-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.styrReady === 'true') return;
      root.dataset.styrReady = 'true';
      const reveals = root.querySelectorAll('.styr-reveal');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: .12, rootMargin: '0px 0px -40px' });
        reveals.forEach((item) => observer.observe(item));
      } else {
        reveals.forEach((item) => item.classList.add('is-visible'));
      }
      const hero = root.querySelector('.styr-hero');
      if (hero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.matchMedia('(pointer: fine)').matches) {
        hero.addEventListener('pointermove', (event) => {
          const x = (event.clientX / window.innerWidth - .5) * 2;
          const y = (event.clientY / window.innerHeight - .5) * 2;
          hero.style.setProperty('--styr-pointer-x', x.toFixed(3));
          hero.style.setProperty('--styr-pointer-y', y.toFixed(3));
        });
      }
    };
    document.querySelectorAll('[data-styr-home]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-styr-home]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
